export const wait = async (breakCallback, attemptCount = 20, timeout = 200) => {
    while (!breakCallback() && --attemptCount !== 0) {
        await delay(timeout);
    }
}

const delay = timeout => new Promise(resolve => setTimeout(resolve, timeout));
